import { SELLING_PLAN_PAGINATION_LIMIT } from '@/constants/shopify'
import { gql } from '@/utilities/commerce'

export default gql`
  fragment order on Order {
    lineItems(first: 250) {
      edges {
        node {
          title
          quantity
          customAttributes {
            key
            value
          }
          variant {
            id
            sku
            title
            availableForSale
            image {
              url
            }
            product {
              handle
              productType
              images(first: 1) {
                edges {
                  node {
                    url
                  }
                }
              }
            }
            price {
              amount
              currencyCode
            }
            sellingPlanAllocations(first: ${SELLING_PLAN_PAGINATION_LIMIT}) {
              nodes {
                sellingPlan {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
    billingAddress {
      address1
      address2
      city
      province
      zip
    }
    orderNumber
    processedAt
    shippingAddress {
      address1
      address2
      city
      phone
      province
      zip
    }
    statusUrl
    totalPrice {
      amount
      currencyCode
    }
    subtotalPrice {
      amount
      currencyCode
    }
    totalShippingPrice {
      amount
      currencyCode
    }
    totalTax {
      amount
      currencyCode
    }
    successfulFulfillments(first: 250) {
      trackingCompany
      trackingInfo(first: 250) {
        number
        url
      }
    }
  }
`
